import useStyles from './styles'
import { CircularProgress, Grid , Typography , InputLabel ,MenuItem , FormControl ,Select } from '@material-ui/core';
import { useState , useEffect , createRef } from 'react';
import PlaceDetails from '../PlaceDetails/PlaceDetails'

const List =({places,childClicked,isLoading,type,setType,rating,setRating}) => {
    const classes = useStyles() ;       //hook for material ui custom styles file   
    const [elementRefs, setElementRefs] = useState([])   //store refs of clicked element on the map 
    
    //refs array for places on the map
    useEffect(() => {
      const refs = Array(places?.length).fill().map((_, i) => elementRefs[i] || createRef())
      setElementRefs(refs);
    }, [places]);

    return (  // showing the select menus & the list of the (PlaceDetails) component & pass data to PlaceDetails component
        <div className={classes.container}>
             <Typography variant="h6" > Restaurants , Hotels and Attractions around you ... </Typography>
             {isLoading? (<div className={classes.loading} > <CircularProgress size='5rem' /></div> ) : 
          (<>  <FormControl className={classes.formControl}>
                 <InputLabel>Type</InputLabel>
                 <Select value={type} onChange={(e)=>setType(e.target.value)}>
                   <MenuItem value='restaurants' >Restaurants</MenuItem>
                   <MenuItem value='hotels' >Hotels</MenuItem>
                   <MenuItem value='attractions' >Attractions</MenuItem>
                 </Select>
             </FormControl>
             <FormControl className={classes.formControl}>
                 <InputLabel>Rating</InputLabel>
                 <Select value={rating} onChange={(e)=>setRating(e.target.value)}>
                   <MenuItem value={0} >All</MenuItem>
                   <MenuItem value={3} >Above 3.0</MenuItem>
                   <MenuItem value={4} >Above 4.0</MenuItem>
                   <MenuItem value={4.5} >Above 4.5</MenuItem>
                 </Select>
             </FormControl>
             <Grid container spacing={3} className={classes.list} > 
                {places?.map((place , i)=>
                        <Grid item ref={elementRefs[i]} key={i} xs={12} >
                          <PlaceDetails place={place} selected={Number(childClicked) === i} refProp={elementRefs[i]}/> 
                        </Grid>
                ) }
             </Grid> </> ) }
        </div>
    )
}

export default List
